const locale = {
	TIMELITE: "TimeLite",
	REPORT: "Report",
	REPORTS: 'Reporte',
	TOTAL: "Gesamt",
	PERIOD: "Periode",
	YEAR: "Jahr",
	MONTH: "Monat",
	INDIVIDUALLY: "Individuell",
	FROM: "von",
	TO: "bis",
	SAVE: "Speichern",
	CANCEL: "Abbrechen",
	ABSENCEREPLACEMENT: "Abwesenheitsvertretung",
	ABSENCEREPLACEMENTASSIGNMENTS: "Vertretungszuweisungen",
	NEWABSENCEREPLACEMENT: "Neue Vertretung",
	EDITABSENCEREPLACEMENT: "Vertretung bearbeiten",
	MYABSENCEREPLACEMENTS: "Meine Abwesenheitsvertretungen",
	NOABSENCEREPLACEMENTSINRANGE: "Sie haben in diesem Zeitraum keine Abwesenheitsvertretungen definiert.",
	NOABSENCEREPLACEMENTASSIGNMENTSINRANGE: "Sie haben in diesem Zeitraum keine Vertretungszuweisungen erhalten.",
	REPLACEMENTUSER: "Vertretung",
	CURRENTREPLACEMENT: "Aktuelle Vertretung",
	ASSIGNEDASREPLACEMENT: "Vertretung für",
	DELETEABSENCEREPLACEMENT: "Abwesenheitsvertretung löschen",
	DELETEABSENCEREPLACEMENTQUESTION: "Möchten Sie diese Abwesenheitsvertretung löschen?",
	CHANGE: "Ändern",
	EXPORT: "Exportieren",
	OBSERVATIONPERIODCHANGE: "Betrachtungszeitraum ändern",
	OBSERVATIONPERIOD: "Betrachtungszeitraum",
	CHOOSEOBSERVATIONPERIOD: "Betrachtungszeitraum auswählen",
	SELECTDATERANGE: "Zeitraum auswählen",
	SELECTDATE: "Datum auswählen",
	PLEASESELECTDATERANGE: "Bitte wählen Sie zuerst einen Zeitraum aus",
	TOTALBALANCE: "Arbeitskonto",
	CURRENTTOTALBALANCE: "Aktuelles Arbeitskonto",
	UNTILLASTMONTHTOTALBALANCE: "Arbeitskonto bis Ende letztes Monat",
	UNTILLASTWEEKTOTALBALANCE: "Arbeitskonto bis Ende letzter Woche",
	ACTUALHOURS: "Istleistung",
	SHOULDHOURS: "Sollleistung",
	ACTUAL: "Ist",
	SHOULD: "Soll",
	VACATIONDAYSBALANCE: "Urlaubskonto",
	CURRENTVACATIONDAYSBALANCE: "Aktuelles Urlaubskonto",
	UNTILLASTMONTHVACATIONDAYSBALANCE: "Urlaubskonto bis Ende letztes Monat",
	UNTILLASTWEEKVACATIONDAYSBALANCE: "Urlaubskonto bis Ende letzter Woche",
	AVAILABLE: "Verfügbar",
	USED: "Verbraucht",
	NEWAVAILABLE: "Neu verfügbar",
	NEWUSED: "Neu verbraucht",
	DETAILVIEW: "Detailansicht",
	ACTIVITYERRORS: "Fehlerhafte Aktivitäten",
	MYACTIVITYERRORS: "Ihre fehlerhaften Aktivitäten",
	OTHERACTIVITYERRORS: "Fehlerhafte Aktivitäten zugeordneter Mitarbeiter",
	ROWSPERPAGE: "Zeilen pro Seite",
	OF: "von",
	DATE: "Datum",
	TIME: "Zeit",
	ACTIVITIES: "Aktivitäten",
	ERRORINFO: "Fehlerinfo",
	ERROR: "Fehler",
	ERRORS: "Fehler",
	BALANCE: "Saldo",
	HIDEDAYSWITHOUTACTIVITIES: "Tage ohne Aktivität ausblenden",
	DAYDETAILS: "Tagesdetails von",
	ACTIVITYTYPE: "Aktivitätsart",
	OBJECT: "Objekt",
	OBJECTS: "Objekte",
	CUSTOMER: "Kunde",
	ACTIVITYDESCRIPTION: "Tätigkeitsbeschreibung",
	DURATION: "Dauer",
	ALL: "Alle",
	EXPORTSELECTEDDATA: "Ausgewählte Daten exportieren",
	EXPORTAS: "Exportieren als",
	EXPORTTYPE: "Export Typ",
	WITHSIGNATURE: "mit Unterschriftenfeld",
	SHOWCALCULATIONTIMESTAMP: "Berechnungszeitpunkt anzeigen",
	SHOWSEALEDREPORT: "Versiegelung im Report anzeigen",
	WITHGRAPHS: "mit grafischen Details",
	DAYTOTALOVERVIEW: "Tagesgesamtübersichten",
	OBJECTTOTALOVERVIEW: "{{object}}gesamtübersichten",
	HYBRIDVIEW: "Hybridansicht",
	SINGLELISTINGS: "Einzelauflistungen",
	INCLUDEPREBALANCE: "Inklusive Saldo davor",
	INCLUDEFUTUREPLANNED: "Inklusive zukünftig geplant",
	PEOPLE: "Personen",
	SUBORDINATEEMPLOYEES: "Zugeordnete Mitarbeiter",
	SELECTEDEMPLOYEE: "Ausgewählter Mitarbeiter",
	BACK: "Zurück",
	NAME: "Name",
	USERNAME: "Benutzername",
	EMAIL: "E-Mail",
	PHONE: "Telefon",
	NODATAFOUND: "Keine Daten verfügbar",
	DAY: "Tag",
	DAYS: "Tage",
	CHARGED: "Angerechnet",
	DEDUCTION: "Abzug",
	CREDIT: "Guthaben",
	MANUALCOMPENSATION: "Manuelle Saldenbuchung",
	MANUALCOMPENSATIONS: "Manuelle Saldenbuchungen",
	AUTOMATICCOMPENSATION: "Automatische Saldenbuchungen",
	TOOBJECT: "auf {{object}}",
	TOOBJECTSHORT: "auf",
	WITHREASON: "mit Begründung",
	WITHNOREASON: "mit keiner Begründung",
	BECAUSEOFTHEOVERTIMEFLATRATE: "Überstundenpauschale",
	REPORTFOR: "Report für",
	CALCULATEDDATE: "Berechnungszeitpunkt",
	SIGNATURESUPERVISOR: "Unterschrift Dienstgeber",
	SIGNATUREEMPLOYEE: "Unterschrift Dienstnehmer",
	SIGNATUREINFOTEXT: "Dienstnehmer und Dienstgeber erklären, dass die aufgezeichneten Daten die tatsächlichen Leistungen wiedergeben und die Aufzeichnungen geprüft und für in Ordnung befunden wurden.",
	ACCEPTANCE: "Abnahme",
	TOTALBALANCETRANSFERFROMBEFORE: "Leistungsübertrag davor",
	VACATIONDAYSBALANCETRANSFERFROMBEFORE: "Urlaubsübertrag davor",
	OBSERVATIONWITHOUTBALANCEBEFORE: "Reiner Betrachtungszeitraum ohne Berücksichtigung der Salden davor.",
	CALCULATIONDATE: "Stand",
	TYPE: "Typ",
	WORKDAY: "Arbeitstag",
	DAYFREE: "Arbeitsfrei",
	HOLIDAY: "Feiertag",
	VACATION: "Urlaub",
	SICKLEAVE: "Krankentand",
	MIXED: "Gemischt",
	INFO: "Info",
	NOACTIVITIESONTHATDAY: "Keine Aktivitäten an diesem Tag vorhanden.",
	LINKNOTVALIDFORUSER: "Dieser Link ist nicht gültig für Ihren Benutzer",
	OVERVIEW: "Übersicht",
	WELCOMEBACK: "Willkommen zurück",
	NOCURRENTTIMELITENOTIFICATIONS: "Sie haben aktuell keine TimeLite Benachrichtigungen",
	WEEK: "Woche",
	CURRENTTIMEACCOUNT: "Echtzeit Ansicht",
	HOURBALANCETODAY: "Saldo Heute",
	QUICKSWITCH: "Schnellwechsel",
	ENDMODE: "Modus beenden",
	ENDMODEEARLY: "Modus frühzeitig beenden",
	CANCELMODE: "Modus abbrechen",
	CLOSEMODE: "Modus abschließen",
	ONOBJECT: "an {{object}}",
	ONOBJECTSHORT: "an",
	WITHOBJECT: "mit {{object}}",
	WITHOBJECTSHORT: "mit",
	SINCE: "seit",
	UNTIL: "bis",
	TIMEPRE: "",
	TIMEPOST: " Uhr",
	ACTIVITYISNOTAPPROVED: "Aktivität wurde noch nicht akzeptiert",
	ACTIVITYHASHIGHERREVISION: "Aktivität hat bereits Änderungen ausstehend",
	STARTAT: "Beginn um",
	START: "Beginn",
	ENDAT: "Ende um",
	END: "Ende",
	STARTNOW: "Sofortbeginn",
	ENDNOW: "Sofortende",
	BACKWARDS: "Rückwirkend",
	OWNTIME: "Eigene Zeit",
	CLOCKINNOW: "Jetzt loslegen",
	CHOOSEAWORKMODE: "Wählen Sie einen Arbeitsmodus aus",
	WORKMODE: "Arbeitsmodus",
	WORKDESCRIPTION: "Tätigkeitsbeschreibung",
	ACTIVITYDESCRIPTION_SUGGESTIONS: "Tätigkeitsbeschreibung Vorschläge",
	ACTIVITYDESCRIPTION_SUGGESTIONS_HELP: "Anzahl der Vorschläge (0 = aus)",
	OBJECTINFORMATION: "{{object}}informationen",
	DESCRIPTION: "Beschreibung",
	ON: "am",
	FULLDAY: "ganztags",
	HALFDAY: "halbtags",
	HALFDAYFIRST: "erste Hälfte",
	HALFDAYSECOND: "zweite Hälfte",
	YESTERDAY: "gestern",
	TOMORROW: "morgen",
	NOACTIVITYACTIVE: "Keine Aktivität aktiv",
	ENDED: "beendet",
	BEGINS: "beginnt",
	AT: "um",
	NOWORKMODEASSIGNED: "Kein Arbeitsmodus zugewiesen",
	OBJECTSASSIGNMENT: "Zuordnung an {{objects}}",
	NOOBJECTASSIGNMENT: "Ohne {{objects}}zuordnung",
	FROMTODAYTO: "von heute bis inkl.",
	TODAY: "Heute",
	ALONGERPERIOD: "Eine längere Zeitspanne",
	CALENDAR: "Kalender",
	ADD: "Hinzufügen",
	LISTVIEW: "Listenansicht",
	MYCALENDAR: "Mein Kalender",
	EMPLOYEECALENDAR: "Mitarbeiterkalender",
	VACATIONCALENDAR: "Urlaubskalender",
	MONTHLYBALANCE: "Monatssaldo",
	WEEKLYBALANCE: "Wochensaldo",
	DAYSBALANCE: "Tagessaldo",
	NEWACTIVITY: "Neue Aktivität",
	LIVECREATIONREQUEST: "Echtzeit Aktivitätserstellung",
	CREATIONREQUEST: "Aktivitätserstellung",
	CHANGEREQUEST: "Aktivitätsänderung",
	DELETEREQUEST: "Aktivitätslöschung",
	SEALDATERANGEREQUEST: "Versiegelungsantrag",
	UNSEALDATERANGEREQUEST: "Entsiegelungsantrag",
	SEALACTIVITYREQUEST: "Versiegelungsantrag",
	UNSEALACTIVITYREQUEST: "Entsiegelungsantrag",
	REQUESTCARD_FROM: "von",
	REQUESTCARD_TO: "zu",
	REQUESTCARD_NEW: "Neu",
	REQUESTCARD_REMOVAL: "Löschung",
	PREVIOUSVERSIONNOTAVAILABLE: "Vorherige Version ist nicht verfügbar",
	SUPERIOR: "Übergeordneter",
	ASSIGNEDACTIVITIES: "Zugeordnete Aktivitäten",
	THEREQUESTWAS: "Der Antrag wurde",
	NOTYETPROCESSED: "noch nicht bearbeitet",
	ACCEPTED: "akzeptiert",
	DECLINED: "abgelehnt",
	ASSIGNEDTO: "Zugewiesen an",
	ACTIVITYHISTORY: "Aktivitätsverlauf",
	ONLINECLOCKIN: "Online gestempelt",
	OFFLINECLOCKIN: "Offline gestempelt",
	ACTIVITYCLOCKEDIN: "Aktivität gestempelt",
	ACTIVITYCREATED: "Aktivität erstellt",
	ACTIVITYREWORK: "Überarbeitung",
	ACTIVITYDELETION: "Löschung",
	UNKNOWN: "Unbekannt",
	ACTIVE: "Aktiv",
	ATTENTION: "Vorsicht",
	SEALQUESTION: "Möchten Sie diese Aktivität wirklich versiegeln?",
	UNSEALQUESTION: "Möchten Sie die Versiegelung dieser Aktivität wirklich aufheben?",
	DELETEQUESTION: "Möchten Sie diese Aktivität wirklich löschen?",
	DELETECOMPENSATIONQUESTION: "Möchten Sie diese Saldobuchung wirklich löschen?",
	DELETEASSIGNMENTQUESTION: "Möchten Sie diese Zuordnung wirklich löschen?",
	YES: "Ja",
	NO: "Nein",
	WORKINGTIMEFRAMEVIEW: "Arbeitszeitrahmen Ansicht",
	WORKINGTIMEVIEW: "Arbeitszeit Ansicht",
	ACTIVITYTIMELINE: "Aktivitäts-Zeitlinie",
	FLEXTIME: "Gleitzeit",
	OUTISDEWORKTIME: "Außerhalb des Arbeitszeitrahmens",
	NORMTIME: "Regelarbeitszeit",
	CORETIME: "Kernarbeitszeit",
	AUTOMATICPAUSE: "Automatische Pausenzeit",
	NOTCALCULATED: "Nicht angerechnet",
	NORMALTIME: "Normalarbeitszeit",
	REDUCEDTIME: "Reduzierte Arbeitszeit",
	OVERTIME: "Überstunden",
	EXTRATIME: "Mehrstunden",
	NEGATIVE: "Negative",
	UNPAID: "Unbezahlte",
	WORKINGTIME: "Arbeitszeit",
	WORKINGTIMES: "Arbeitszeiten",
	LASTONLINE: "Zuletzt online",
	NEVER: "Nie",
	CONFIRM: "Annehmen",
	REJECT: "Ablehnen",
	CONFIRMREQUESTQUESTION: "Der Antrag enthält mehrere Aktivitäten. Sie bestätigen somit alle verknüpften Aktivitäten.",
	REJECTREQUESTQUESTION: "Der Antrag enthält mehrere Aktivitäten. Sie lehnen somit alle verknüpften Aktivitäten ab.",
	FORWARDREQUEST: "Antrag weiterleiten",
	SUPERVISOR: "Vorgesetzter",
	FORWARD: "Weiterleiten",
	ASSIGNTO: "An",
	ASSIGNCOMMENT: "Weiterleitungskommentar",
	REQUESTCREATED: "Antrag erstellt",
	REQUESTREOPENED: "Antrag wieder geöffnet",
	REQUESTHISTORY: "Antragsverlauf",
	REQUESTHISTORY_CREATED: "Antrag wurde von {{user}} erstellt",
	REQUESTHISTORY_REOPENED: "Antrag wurde von {{user}} wieder geöffnet",
	REQUESTHISTORY_FORWARDED: "Antrag wurde von {{user}} weitergeleitet",
	REQUESTHISTORY_ANSWERED: "Antrag wurde von {{user}} beantwortet",
	REQUESTHISTORY_ACCEPTED: "Antrag wurde von {{user}} angenommen",
	REQUESTHISTORY_DECLINED: "Antrag wurde von {{user}} abgelehnt",
	REQUESTHISTORY_ANSWER_CHANGED: "Antwort wurde von {{user}} geändert",
	REQUESTHISTORY_ANSWER_CHANGED_ACCEPTED: "Antwort wurde von {{user}} auf angenommen geändert",
	REQUESTHISTORY_ANSWER_CHANGED_DECLINED: "Antwort wurde von {{user}} auf abgelehnt geändert",
	REQUESTHISTORY_PURPOSE_CHANGED: "Antragszweck wurde von {{user}} geändert",
	REQUESTHISTORY_JUSTIFICATION_CHANGED: "Begründung wurde von {{user}} geändert",
	REQUESTPURPOSE: "Antragszweck",
	JUSTIFICATION: "Begründung",
	COMMENTTRAIL: "Antragsverlauf",
	FORWARDCOMMENT: "Weiterleitungskommentar",
	REQUESTPURPOSECHANGED: "Antragszweck geändert",
	JUSTIFICATIONCHANGED: "Begründung geändert",
	ANSWERCHANGED: "Antwort geändert",
	PREVIOUS: "Vorheriger Wert",
	REQUESTSOFME: "Aktuelle Anträge von Ihnen",
	REQUESTSTOME: "Aktuelle Anträge an Sie",
	REQUESTS: "Anträge",
	PREVIOUSREQUESTSOFME: "Abgeschlossene Anträge von Ihnen",
	PREVIOUSREQUESTSTOME: "Abgeschlossene Anträge an Sie",
	LOADREQUESTHISTORY: "Antragsverlauf laden",
	NOREQUESTSFOUND: "Keine Anträge gefunden",
	OFTHELAST: "von den letzten",
	CURRENTSTATE: "Aktueller Status",
	ONLINE: "Online",
	OFFLINE: "Offline",
	AWAY: "Abwesend",
	WORKING: "Arbeitet gerade",
	NOTAVAILABLE: "Nicht verfügbar",
	CREATEDAT: "Erstellt am",
	CREATED: "Erstellt",
	ANSWER: "Antwort",
	ACCEPT: "Annehmen",
	DECLINE: "Ablehnen",
	INDIVIUDALMODE: "Individuell",
	HOURLYMODE: "Stündlich",
	HALFDAYMODE: "Halbtags",
	FULLDAYMODE: "Ganztags",
	MANUALBALANCECOMPENSATION: "Manuelle Saldobuchung",
	SETABSOLUTEBALANCE: "Absolutes Saldo setzen",
	TARGETBALANCEVALUE: "Zielwert",
	ABSOLUTEBALANCENOFUTUREINFO: "Der aktuelle Saldo als Berechnungsgrundlage an diesem Tag berücksichtigt keine zukünftig geplanten Aktivitäten.",
	COMPENSATIONAMOUNT: "Menge",
	FIRSTHALF: "Erste Hälfte",
	SECONDHALF: "Zweite Hälfte",
	COMPENSATIONTYPE: "Modus",
	COMPENSATIONUNIT: "Einheit",
	SECONDS: "Sekunden",
	MINUTES: "Minuten",
	HOURS: "Stunden",
	DAYS: "Tage",
	SHOULDHOURSDIVISION: "Istleistungsaufteilung",
	WORKMODEDIVISION: "Arbeitsmodusaufteilung",
	OBJECTDIVISION: "{{object}}aufteilung",
	OBJECTDIVISIONPERCENTAGEINFO: "Die Werte basieren auf allen Arbeitsmodi, inklusive eventuellem Urlaub und Abwesenheiten - siehe Arbeitsmodusaufteilung.",
	OBJECTCOMBINATIONDIVISION: "Objektzuordnungskombination",
	TOTALUNTIL: "Gesamt bis zum",
	CURRENTAPERIODUNTIL: "Aktuelles Zeiterfassungssaldo am",
	CURRENTAPERIOD: "Aktuelles Zeiterfassungssaldo",
	SIMULATETERMINATION: "Simuliere Austritt an diesem Datum",
	LASTWEEK: "letzte Woche",
	LASTMONTH: "letztes Monat",
	CALENDARWEEK: "Kalenderwoche",
	BALANCEDIFFERENCE: "Leistungsdifferenz",
	VACATIONDIFFERENCE: "Urlaubsdifferenz",
	EXPANDALL: "Alles aufklappen",
	COLLAPSEALL: "Alles zuklappen",
	BEFORE: "Davor",
	AFTER: "Danach",
	TEAMABSENCECALENDAR: "Abwesenheitskalender",
	INSERTEDAT: "eingelangt am",
	DISABLED: "Deaktiviert",
	NOTEMPLOYED: "Nicht angestellt",
	NEXTDAY: "nächsten Tag",
	ASSIGNED: "Zugewiesen",
	CREATENEWOBJECT: "{{object}} hinzufügen",
	EDITOBJECT: "{{object}} bearbeiten",
	EDIT: "Bearbeiten",
	ME: "mir",
	OBJECTSNOTAVAILABLE: "Tut uns leid, Sie haben keine {{objects}} zugewiesen und dürfen auch keine erstellen.",
	THISFIELDISREQUIRED: "Dieses Feld muss ausgefüllt werden",
	ICON: "Icon",
	COLOR: "Farbe",
	CANSEEWHOLEDATA: "Kann alle Daten einsehen",
	OPEN: "offen",
	SEALED: "Versiegelt",
	PARTIALLYSEALED: "Teilweise versiegelt",
	ALREADYSEALED: "bereits versiegelt",
	REQUEST: "Antrag",
	REQUESTWILLBECREATED: "Für diese Aktion wird ein Antrag erstellt.",
	DAYISSEALED: "Tag ist versiegelt",
	UNSEALDATERANGEQUESTION: "Möchten Sie die Versiegelung des nachfolgenden Zeitraumes wirklich aufheben?",
	SEALDATERANGE: "Zeitraum versiegeln",
	SEALDATERANGECONFIRM: "Möchten Sie den Zeitraum beim Exportieren dieses Reports wirklich versiegeln?",
	DATERANGEALREADYSEALED: "Dieser Zeitraum ist bereits versiegelt. Der Export wird ohne zusätzliche Versiegelung fortgesetzt.",
	SEALEDRANGES: "Bestehende versiegelte Zeiträume",
	SEAL: "Versiegeln",
	UNSEAL: "Entsiegeln",
	SEALACTIVITY: "Aktivität versiegeln",
	UNSEALACTIVITY: "Aktivität entsiegeln",
	SEALACTION: "Aktion",
	TARGET: "Ziel",
	COPYACTIVITY: "Aktivität kopieren",
	ACTIVITYVIEW: "Aktivitätsansicht",
	ACTIVITYDESCRIPTION: "Aktivitätsbeschreibung",
	NODESCRIPTION: "Keine Beschreibung",
	WITHOUTOBJECT: "Ohne Objektzuordnung",
	PARTDAYS: "Halbtage",
	ALREADYPLANNED: "Schon geplant",
	UPDATE: "Aktualisieren",
	UPDATEACTIVITY: "Aktivität aktualisieren",
	PARENTOBJECT: "Übergeordnetes {{object}}",
	NOPARENTOBJECT: "Kein übergeordnetes {{object}}",
	LOCKOBJECT: "{{object}} sperren",
	ARCHIVEOBJECT: "{{object}} archivieren",
	SEARCH: "Suche",
	NOOBJECTSSFOUND: "Keine {{objects}} gefunden",
	FINISHED: "Abgeschlossen",
	ARCHIVED: "Archiviert",
	STATE: "Status",
	STARTSAT: "Beginnt am",
	ENDEDAT: "Aufgehört am",
	SHOWBUDGET: "Budgetaktivierung",
	INTERNALPRICE: "Interner Stundensatz",
	EXTERNALPRICE: "Verrechenbarer Stundensatz",
	BASEEXTERNALPRICE: "Verrechenbarer Basisstundensatz",
	HOURLYWAGE: "Stundensatz",
	PLANNEDTOTALBUDGET: "Geplantes Gesamtbudget",
	PLANNEDTOTALHOURS: "Geplante Gesamtstunden",
	TOTALBUDGET: "Gesamtbudget",
	INVALIDINPUT: "Ungültige Eingabe",
	SELECTALL: "Alles auswählen",
	SELECTNOTHING: "Alles abwählen",
	SELECTALLACTIVE: "Alle aktiven auswählen",
	SELECTALLFINISHED: "Alle abgeschlossenen auswählen",
	SELECTNOTHINGACTIVE: "Alle aktiven abwählen",
	SELECTNOTHINGFINISHED: "Alle abgeschlossenen abwählen",
	LISTVIEW: "Listenansicht",
	CARDVIEW: "Kartenansicht",
	ISLOADING: "wird geladen",
	LOADING: "Laden...",
	LOADINGDETAILS: "Daten werden generiert. Bitte warten...",
	LOADINGDATA: "Daten werden geladen. Bitte warten...",
	DETAILS: "Details",
	TOTHEREPORTS: "Zu den Reporten",
	TOTHECALENDAR: "Zum Kalendar",
	TOCALENDAR: "Zum Kalender",
	RECALCALL: "Alle Salden neu berechnen",
	RECALCALLINFO: "Alle Salden für diesen Nutzer werden neu berechnet, dies kann bis zu einer Minute lang dauern.",
	PRICE: "Preis",
	TOTALHOURS: "Gesamtstunden",
	TOTALPRICE: "Gesamtpreis",
	EMPLOYEES: "Mitarbeiter",
	EMPLOYEE: "Mitarbeiter",
	LISTINGPERUSER: "Auflistung nach Mitarbeiter",
	LISTINGPERDAY: "Auflistung nach Tagen",
	TOTALPRICETRANSFERFROMBEFORE: "Preisübertrag davor",
	TOTALHOURSPEREMPLOYEE: "Gesamtstunden pro Mitarbeiter",
	TOTALPRICEPEREMPLOYEE: "Gesamtpreis pro Mitarbeiter",
	BALANCEDIVISION: "Leistungsverteilung",
	WITHBUDGET: "mit Budget",
	SIGNATURECOMPANY: "Unterschrift Dienstleister",
	SIGNATURECUSTOMER: "Unterschrift Kunde",
	OBJECTSIGNATUREINFOTEXT: "Dienstleister und Kunde erklären, dass die aufgezeichneten Daten die tatsächlichen Leistungen wiedergeben und die Aufzeichnungen geprüft und für in Ordnung befunden wurden.",
	DETAILEDVIEWFOR: "Detailansicht für",
	COMBINED: "kombiniert",
	PEREMPLOYEE: "pro Mitarbeiter",
	ADMINS: "Admins",
	MINIMUMONE: "Minimum 1",
	QUICKASSIGNMENTS: "Schnellzuweisungen",
	DETAILLIST: "Detailauflistung",
	ASSIGNMENTS: "Zuweisungen",
	COUNTRY: "Land",
	PROVINCE: "Bundesland/Region",
	POSTALCODE: "Postleitzahl",
	CITY: "Stadt",
	STREET: "Straße",
	ADDRESSADDITION: "Adresszusatz",
	CUSTOMFIELDS: "Benutzerdefinierte Felder",
	ADDACUSTOMFIELD: "Benutzerdefiniertes Feld hinzufügen",
	LABEL: "Bezeichnung",
	VALUE: "Inhalt",
	ADDRESS: "Adresse",
	MOREINFOS: "Weitere Informationen",
	INHERIT: "Standard",
	DENY: "Verbieten",
	ALLOW: "Erlauben",
	FORCE: "Erzwingen",
	NOTSET: "Nicht gesetzt",
	NEWASSIGNMENT: "Neue Zuweisung",
	CALCULATIONMODE: "Berechnungsmodus",
	CALCULATIONMODEREALTIME: "Echtzeit ohne Zuschläge oder Abzüge",
	CALCULATIONMODEUSEDTIME: "Nutzzeit inkl. Zuschläge und Abzüge",
	SHOWONREPORT: "Zeige in den Reporten",
	HIERACHYROLE: "Hierachierolle",
	USABLE: "Benützbar",
	NOTUSABLE: "Nicht mehr benützbar",
	OBJECTLINKS: "Objektverlinkungen",
	SELECTIONEXCEEDSMAX: "Auswahl übersteigt das Maximum",
	TOTALERRORCOUNTER: "Aktivitätsfehler",
	SETTINGS: "Einstellungen",
	INCLUDECOMPENSATIONS: "Inklusive Saldenbuchungen",
	HIGHLIGHTED: "Hervorgehoben",
	USEROVERVIEW: "Mitarbeiterübersicht",
	DISPLAYTYPE: "Anzeigeart",
	BUDGETANDPLAN: "Budget & Planung",
	OBJECTMANAGEMENT: "{{object}}verwaltung",
	BASEINFORMATION: "Basisinformationen",
	MANUALREPORTS: "Manuelle Reporte",
	AUTOMATICREPORTS: "Automatische Reporte",
	REPORTTYPE: "Reportart",
	NEXT: "Weiter",
	GENERATEREPORT: "Report generieren",
	OBJECTSELECTION: "{{object}}auswahl",
	CHOOSEOBJECTITEM: "{{objects}} auswählen",
	CHOOSEAREPORTTYPE: "Reportart auswählen",
	CHOOSEEMPLOYEES: "Mitarbeiter auswählen",
	NOEMPLOYEESFOUND: "Keine Mitarbeiter gefunden",
	ONEPDFFORALLUSER: "Eine PDF Datei für alle Mitarbeiter",
	EXTRAPDFPERUSER: "Getrennte PDF Dateien pro Mitarbeiter",
	COMBINEDEXCELOFUSER: "Eine EXCEL Liste aller Mitarbeiter",
	EXTRAEXCELTABSPERUSER: "Eigene EXCEL Tabs pro Mitarbeiter",
	EXTRAEXCELPERUSER: "Getrennte EXCEL Dateien pro Mitarbeiter",
	SHORTSUMMARY: "Kurzzusammenfassung",
	ONEPDFFORALLOBJECT: "Eine PDF Datei für alle {{objects}}",
	EXTRAPDFPEOBJECT: "Getrennte PDF Dateien pro {{object}}",
	COMBINEDEXCELOFOBJECT: "Eine EXCEL Liste aller {{objects}}",
	EXTRAEXCELTABSPEROBJECT: "Eigene EXCEL Tabs pro {{object}}",
	EXTRAEXCELPEROBJECT: "Getrennte EXCEL Dateien pro {{object}}",
	MULTIPLEOBJECTSLINKED: "Mehrere Zuordnungen",
	NEW: "Neu",
	MULTIPLEEMPLOYEES: "Mehrere Mitarbeiter",
	MULTIPLEOBJECTS: "Mehrere Objekte",
	MULTIPLEOBJECTSSPECIFIC: "Mehrere {{objects}}",
	DATEANDTIMEFORMAT: "Formatierung Datum & Zeit",
	DURATIONANDSUMFORMAT: "Formatierung Dauer & Summe",
	DATEANDTIMECOMBINED: "Datum & Zeit kombiniert",
	DATEANDTIMESPLIT: "Datum & Zeit getrennt",
	WITHSECONDS: "mit Sekunden",
	FROMDATE: "von Datum",
	FROMTIME: "von Zeit",
	TODATE: "bis Datum",
	TOTIME: "bis Zeit",
	TODAYSHISTORY: "Heutiger Tagesablauf",
	NOACTIVITIESFOUND: "Keine Aktivitäten gefunden",
	EMPLOYEESSEARCH: "Mitarbeiter durchsuchen",
	TASKS: "Aufgaben",
	MYTASKS: "Meine Aufgaben",
	SUBORDINATESTASKS: "Aufgaben der Mitarbeiter",
	TASKS_VIEW_USER: "Nach Benutzer",
	TASKS_VIEW_OBJECTITEM: "Nach Objekt",
	TASKS_NEW: "Neue Aufgabe",
	TASKS_NEW_TASK: "Neue Aufgabe",
	TASKS_FOR_ME: "Für mich",
	TASKS_ASSIGNED_TO: "Zugewiesen an",
	TASKS_EDIT_TASK: "Aufgabe bearbeiten",
	TASKS_NO_TASKS: "Keine Aufgaben verfügbar",
	SEARCH_NO_RESULTS: "Keine Aufgaben entsprechen Ihrer Suche",
	TASKS_OPEN_TASKS: "Ihre offenen Aufgaben",
	TASKS_NO_OBJECT_ASSIGNMENT: "Keine Objektzuweisung",
	TASKS_CLOSED_TASKS: "Abgeschlossen",
	TASKS_UPCOMING_TASKS: "Bevorstehend",
	TASKS_DUE: "Fällig",
	TASKS_DUE_AT: "Fällig am",
	TASKS_DUE_SINCE: "Fällig seit",
	TASKS_OPEN: "Offen ab",
	TASKS_OPEN_SINCE: "Offen seit",
	TASKS_OPEN_INSTANTLY: "Sofort",
	TASK_ACTION_SUCCESS: "Aufgabenaktion erfolgreich abgeschlossen",
	TASK_DETAILS: "Aufgabendetails",
	TASK_NAME: "Aufgabenname",
	TASK_TYPE: "Aufgabentyp",
	PRIORITY_VERY_HIGH: "Sehr hoch",
	PRIORITY_HIGH: "Hoch",
	PRIORITY_NORMAL: "Normal",
	PRIORITY_LOW: "Niedrig",
	PRIORITY_VERY_LOW: "Sehr niedrig",
	TASK_STATUS_OPEN: "Offen",
	TASK_STATUS_DONE: "Erledigt",
	TASK_STATUS_FAILED: "Fehlgeschlagen",
	TASK_STATUS_ABORTED: "Abgebrochen",
	TASK_STATUS_IGNORED: "Ignoriert",
	DESCRIPTION: "Beschreibung",
	STATUS: "Status",
	PRIORITY: "Priorität",
	ASSIGNED_TO: "Zugewiesen an",
	OBJECTITEM: "Objekt",
	OBJECT_ASSIGNMENT: "Objektzuweisung",
	REVISION: "Revision",
	COMMENT: "Kommentar",
	COMMENTS: "Kommentare",
	CREATING_COMMENT: "Erstellungskommentar",
	CLOSING_COMMENT: "Abschlusskommentar",
	CLOSED: "Geschlossen",
	CLOSED_AT: "Geschlossen am",
	HISTORY: "Verlauf",
	EDITED: "Bearbeitet",
	REOPENED: "Wiedereröffnet",
	OVERDUE: "Überfällig",
	NO_DUE_DATE: "Keine Fälligkeit",
	OPEN_DATE_AFTER_DUE_DATE: "Startdatum darf nicht nach dem Fälligkeitsdatum liegen",
	EDIT: "Bearbeiten",
	DELETE: "Löschen",
	CREATE_TASK: "Aufgabe erstellen",
	EDIT_TASK: "Aufgabe bearbeiten",
	CLOSE_TASK: "Aufgabe schließen",
	REOPEN_TASK: "Aufgabe wiedereröffnen",
	REASSIGN_TASK: "Aufgabe neu zuweisen",
	REASSIGNED: "Neu zugewiesen",
	REASSIGNED_TO: "Neu zugewiesen an",
	DELETE_TASK: "Aufgabe löschen",
	DELETE_TASK_CONFIRM: "Möchten Sie diese Aufgabe wirklich löschen?",
	CLOSE_TYPE: "Abschlusstyp",
	UPDATE: "Aktualisieren",
	CREATE: "Erstellen",
	CREATED_BY: "Erstellt von",
	CREATED_AT: "Erstellt am",
	MILESTONES: "Meilensteine",
	EFFECTIVEMILESTONES: "Effektive Meilensteine",
	PLANNEDMILESTONES: "Geplante Meilensteine",
	DATETIME: "Datum & Uhrzeit",
	NAME: "Name",
	PERCENTAGE: "Prozentsatz",
	PROGRESS: "Fortschritt",
	ACTIONS: "Aktionen",
	PREVIEW: "Vorschau",
	PREVIEW_TOOLTIP: "Noch nicht vollständig implementiert",
	BEHIND_SCHEDULE: "Im Verzug",
	BEHIND_MILESTONE_SCHEDULE: "Dieses Objekt liegt hinter dem geplanten Meilensteinplan zurück",
	MILESTONE_PROGRESS: "Meilenstein-Fortschritt",
	MILESTONE_MULTIPLE_SAME_DAY_NOTE: "Hinweis: Wenn mehrere Meilensteine am selben Tag erstellt werden, wird der höchste Fortschritt für dieses Datum verwendet.",
	PLANNED: "Geplant",
	MORE_OPTIONS: "Weitere Optionen",
	CLOSE: "Schließen",
	REASSIGN_TASK: "Aufgabe zuweisen",
	REASSIGNED: "Zugewiesen",
	REASSIGN_TO: "Zuweisen an",
	REASSIGN_COMMENT: "Kommentar (optional)",
	REASSIGNED_TO: "Zugewiesen an",
	NO_OPTIONS: "Keine Optionen",
	ADDFAVORITE: "Zu Favoriten hinzufügen",
	REMOVEFAVORITE: "Aus Favoriten entfernen",
	FAVORITE: "Favorit",
	REPORTHISTORY: "Report Verlauf",
	RUNINBACKGROUND: "Im Hintergrund ausführen",
	DELETEALLHISTORY: "Gesamten Verlauf löschen",
	NOHISTORYREPORTS: "Keine Reporte im Verlauf",
	HISTORYSAVEDREPORTNOTICE: "Dies ist ein zuvor gespeicherter Report. Die Daten können vom aktuellen Stand abweichen.",
	GENERATEDAT: "Erstellt am",
	REPORT_HISTORY_REMAINING_DAYS: "Noch {{count}} Tage verfügbar",
	REPORT_HISTORY_EXPIRES_TODAY: "Läuft heute ab",
	REPORTGENERATEDINBACKGROUND: "Bericht wird im Hintergrund generiert.",
	FOR: "für",
	REPORT_STATUS_PENDING: "Ausstehend",
	REPORT_STATUS_RUNNING: "Wird generiert",
	REPORT_STATUS_COMPLETED: "Abgeschlossen",
	REPORT_STATUS_FAILED: "Fehlgeschlagen",
	ACTIVITY_TEMPLATES: "Aktivitätsvorlagen",
	ACTIVITY_TEMPLATE: "Aktivitätsvorlage",
	SELECT_TEMPLATE: "Vorlage auswählen",
	REMOVE_TEMPLATE: "Vorlage entfernen",
	NO_TEMPLATES: "Keine Vorlagen verfügbar",
	TEMPLATE_NAME: "Vorlagenname",
	TEMPLATE_APPLIED: "Vorlage angewendet",
	PERSONAL_TEMPLATE: "Persönlich",
	COMPANYWIDE_TEMPLATE: "Firmenweit",
	TEMPLATE_ITEMS_REMOVED: "Einige Elemente sind nicht mehr zugewiesen und wurden nicht übernommen.",
	EXTERNAL_IMPORT_FROM_EXTERNAL_CALENDAR: "Von externem Kalender importieren",
	PROVIDER_MICROSOFT: "Microsoft 365",
	PROVIDER_GOOGLE: "Google",
	EXTERNAL_NO_EVENTS: "Für diese Auswahl wurden keine Termine gefunden.",
	EXTERNAL_ALL_DAY: "Ganztägig",
	EXTERNAL_PRIVATE_EVENT: "Privat",
	SORTBY: "Sortieren nach",
	SORTORDER: "Sortierreihenfolge",
	SORT_BY_DISPLAYNAME: "Anzeigename",
	SORT_BY_FIRSTNAME: "Vorname",
	SORT_BY_LASTNAME: "Nachname",
	SORT_ASCENDING: "Aufsteigend",
	SORT_DESCENDING: "Absteigend",
	RECURRING: "Wiederkehrend",
	RECURRING_TASK: "Wiederkehrende Aufgabe",
	RECURRING_INTERVAL: "Intervall",
	RECURRING_UNTIL: "Wiederholen",
	END_RECURRING_TASK: "Wiederholungsserie beenden",
	END_RECURRING_TASK_CONFIRM: "Sollen keine weiteren Aufgaben dieser wiederkehrenden Serie erstellt werden?",
	RECURRING_BADGE: "Wiederkehrend",
	RECURRING_REQUIRES_OPEN_DATE: "Zuerst ein Offen ab-Datum setzen, um Wiederholung zu aktivieren",
	RECURRING_BASE: "Basis",
	RECURRING_BASE_OPEN: "Offen ab",
	RECURRING_BASE_DUE: "Fälligkeit",
	RECURRING_BASE_REQUIRES_DUE: "Fälligkeitsdatum setzen, um Fälligkeit als Wiederholungsbasis zu verwenden",
	RECURRING_EVERY: "jede",
	RECURRING_ORDINAL_SUFFIX: ".",
	RECURRING_UNTIL_DATE_PREFIX: "bis",
	RECURRING_NEXT_AFTER_CLOSE_INFO: "Die nächste wiederkehrende Aufgabe wird erst erstellt, nachdem die aktuelle Aufgabe aus dieser Serie geschlossen wurde.",
	RECURRING_BASE_INFO: "Legt fest, welches Datum durch das Intervall bestimmt wird. 'Basis: Offen ab' bedeutet, das Intervall bestimmt das nächste Öffnungsdatum — das Fälligkeitsdatum wird durch Addition der Tagesdifferenz berechnet. 'Basis: Fälligkeit' bedeutet, das Intervall bestimmt das nächste Fälligkeitsdatum — das Öffnungsdatum wird durch Subtraktion der Tagesdifferenz berechnet.",
	UNIT_DAY: "Tage",
	UNIT_WEEK: "Wochen",
	UNIT_MONTH: "Monate",
	UNIT_QUARTER: "Quartale",
	UNIT_HALFYEAR: "Halbjahre",
	UNIT_YEAR: "Jahre",
	UNIT_TIMES: "Mal",
	UNIT_UNTIL_DATE: "Festes Datum",
	UNIT_STARTOFWEEK: "Beginn der Woche",
	UNIT_ENDOFWEEK: "Ende der Woche",
	UNIT_STARTOFMONTH: "Beginn des Monats",
	UNIT_ENDOFMONTH: "Ende des Monats",
	UNIT_STARTOFQUARTER: "Beginn des Quartals",
	UNIT_ENDOFQUARTER: "Ende des Quartals",
	UNIT_STARTOFHALFYEAR: "Beginn des Halbjahres",
	UNIT_ENDOFHALFYEAR: "Ende des Halbjahres",
	UNIT_STARTOFYEAR: "Beginn des Jahres",
	UNIT_ENDOFYEAR: "Ende des Jahres",
};

export default locale;
